import { configureStore, combineReducers } from "@reduxjs/toolkit";
import logger from "redux-logger";

import authReducer from "./AuthSlice/index";
import loadingReducer from "./LoaderSlice/index";
import modalReducer from "./ModalSlice/index";
import peopleReducer from "./PeopleSlice/index";
import managerReducer from "./ManagerSlice/index";
import requestReducer from "./RequestSlice/index";
import taskboxReducer from "./TaskboxSlice/index";
import seperationReducer from "./SeperationSlice/index";
import attendanceReducer from "./AttendanceSlice/index";
import onboardingReducer from "./OnboardingSlice/index";

import { thunk } from "redux-thunk";
import { setStoreRef } from ".";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import localStorage from "redux-persist/es/storage";
import { createTransform } from "redux-persist";

const rootReducer = combineReducers({
  auth: authReducer,
  loader: loadingReducer,
  modal: modalReducer,
  people: peopleReducer,
  manager: managerReducer,
  request: requestReducer,
  taskbox: taskboxReducer,
  seperation: seperationReducer,
  attendance: attendanceReducer,
  onboarding: onboardingReducer,
});


const authTransform = createTransform(
  (inboundState, key) => {
    if (key !== "auth") return inboundState;

    const { accessToken, refreshToken, customToken, ...rest } = inboundState;
    return rest;
  },
  (outboundState, key) => outboundState,
  { whitelist: ["auth"] }
);

const persistConfig = {
  key: "root",
  storage: localStorage,
  transforms: [authTransform],
  // Keep ephemeral API caches (e.g. onboarding dropdown) out of localStorage
  // so a stale SUCCESS state cannot permanently skip network calls.
  blacklist: ["onboarding", "loader", "modal"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middleware = [thunk];

if (process.env.NODE_ENV !== "production") {
  middleware.push(logger);
}

let store = configureStore({
  reducer: persistedReducer,
  middleware: () => middleware,
});

export const persistor = persistStore(store);

export default store;

setStoreRef(store);
